import is from './is';
const date = Object.freeze({
  format: (date: string | number | Date, options?: Intl.DateTimeFormatOptions) => {
    if (!date) return '';
    const dateString = new Date(date);
    if (is.valid.date(dateString)) {
      const defaultOptions = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'Asia/Kolkata',
        ...(options ?? {}),
      };
      return dateString
        .toLocaleDateString('en-IN', defaultOptions as any)
        ?.replace('am', 'AM')
        ?.replace('pm', 'PM');
    }
    return '';
  },
  formatTime: (date: string | number | Date, options?: Intl.DateTimeFormatOptions) => {
    if (!date) return '';
    const dateString = new Date(date);
    if (is.valid.date(dateString)) {
      const defaultOptions = {
        hour12: true,
        timeZone: 'Asia/Kolkata',
        ...(options ?? {}),
      };
      return dateString
        .toLocaleTimeString('en-IN', defaultOptions as any)
        ?.replace('am', 'AM')
        ?.replace('pm', 'PM');
    }
    return '';
  },
  getPlanInYears: (startDate: string, endDate: string): number => {
    const timeDifference = new Date(endDate).getTime() - new Date(startDate).getTime();
    const differenceInYears = Math.ceil(timeDifference / (365.25 * 24 * 60 * 60 * 1000));
    return differenceInYears;
  },

  getPlanInDays: (startDate: string, endDate: string): number => {
    const timeDifference = new Date(endDate).getTime() - new Date(startDate).getTime();
    const differenceInDays = Math.ceil(timeDifference / (24 * 60 * 60 * 1000));
    return differenceInDays;
  },

  getTimeInHours: (dateInString: string): number => {
    const targetDate = new Date(dateInString);
    const currentTime = new Date();
    const timeDifferenceMs = targetDate.getTime() - currentTime.getTime();
    const hoursDifference = Math.ceil(timeDifferenceMs / (1000 * 60 * 60));

    return hoursDifference;
  },

  getEndingDay: (dateInString: string): string => {
    const targetDate = new Date(dateInString);
    const currentDate = new Date();

    const timeDifferenceMs = targetDate.getTime() - currentDate.getTime();
    const daysDifference = Math.ceil(timeDifferenceMs / (1000 * 60 * 60 * 24));

    if (daysDifference === 0) {
      return 'today';
    } else if (daysDifference === 1) {
      return 'tomorrow';
    } else {
      return '';
    }
  },

  getRoundedTime: (dateStr: string): string => {
    const date = new Date(dateStr);

    let hours = date.getHours();

    const period = hours < 12 ? 'AM' : 'PM';

    if (hours > 12) {
      hours -= 12;
    }

    const roundedHours = Math.ceil(hours);

    return `${roundedHours} ${period}`;
  },

  getDaysDifferenceforCoupon: (timestamp: number): string => {
    const currentTimeStamp = Date.now();
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const differenceInMilliseconds = Math.abs(timestamp - currentTimeStamp);
    const daysDifference = Math.floor(differenceInMilliseconds / millisecondsPerDay);
    if (daysDifference > 7) return '';
    if (daysDifference === 0) {
      const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
      // Calculate hours, minutes, and seconds
      const hours = Math.floor(differenceInSeconds / 3600);
      const minutes = Math.floor((differenceInSeconds % 3600) / 60);
      const seconds = differenceInSeconds % 60;
      // Format the time as HH:MM:SS
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');
      return `Expiring in ${formattedHours}:${formattedMinutes} hours`;
    } else {
      return `Expiring in ${daysDifference} ${daysDifference > 1 ? 'days' : 'day'}`;
    }
  },
  getDifferenceInYears(startDateStr: string, endDateStr: string) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    const timeDiff = endDate.getTime() - startDate.getTime();

    const yearDiff = timeDiff / (1000 * 60 * 60 * 24 * 365.25);

    return Math.round(yearDiff);
  },
  getUTCFormattedDate(date: Date) {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  },

  compareFirstDateEarlier(firstDate: number | Date, secondDate: number | Date) {
    const firstTime = typeof firstDate === 'number' ? firstDate : firstDate?.getTime();
    const secondTime = typeof secondDate === 'number' ? secondDate : secondDate?.getTime();
    return firstTime <= secondTime;
  },
  webEnagageFormat(date: string) {
    return `${date?.replace('T', ' ')}:00`;
  },
  isOlderThanSpecifiedDays(date: number | Date, days: number): boolean {
    const timestamp = typeof date === 'number' ? date : date?.getTime();
    const thresholdValue = days * 24 * 60 * 60 * 1000;
    return Date.now() - timestamp > thresholdValue;
  },
  convertStrToSlot(input: string) {
    // DDMMYYYY HH:MM AM/PM
    const day = input.slice(0, 2);
    const month = input.slice(2, 4);
    const year = input.slice(4, 8);
    const timePart = input.slice(9);
    const startTime = new Date(`${month}/${day}/${year} ${timePart} GMT+0530`);
    const endTime = new Date(startTime).setHours(startTime.getHours() + 1);

    return {
      serviceDate: new Date(`${month}/${day}/${year}`),
      serviceSlot: {
        available: true,
        slot: { startTime, endTime: new Date(endTime) },
        workerCode: [],
        slotDuration: 1,
      },
    };
  },
  // isWithinBusinessHours({
  //   startHour = 8,
  //   endHour = 20,
  //   activeDays = [1, 2, 3, 4, 5, 6],
  //   date = new Date(),
  // } = {}) {
  //   const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
  //   const istTime = new Date(date.getTime() + istOffset);

  //   const day = istTime.getUTCDay(); // 0 = Sunday, 6 = Saturday
  //   const hour = istTime.getUTCHours();

  //   const isWithinHours = hour >= startHour && hour < endHour;
  //   const isWithinDays = activeDays.includes(day);

  //   return isWithinHours && isWithinDays;
  // },
});

export default date;
